import isNil from 'lodash.isnil'

export enum NumberFormat {
  Integer,
  Float,
  Currency,
  Percentage, // percentage assumes that the number entered is an int, i.e. 3 = 3%, NOT 0.03
}

export type FormatNumberArgs = {
  format?: NumberFormat
  maximumFractionDigits?: number
  minimumFractionDigits?: number
  useGrouping?: boolean
}

export const formatNumber = (value: number | null | undefined, args?: FormatNumberArgs): string => {
  if (isNil(value) || isNaN(value)) {
    return ''
  }

  const format = args?.format ?? NumberFormat.Integer
  const useGrouping = args?.useGrouping ?? true
  let minimumFractionDigits = 0
  let maximumFractionDigits = 0
  switch (format) {
    case NumberFormat.Currency:
      minimumFractionDigits = 2
      maximumFractionDigits = 2
      break
    case NumberFormat.Float:
      maximumFractionDigits = 10
      break
    case NumberFormat.Percentage:
      maximumFractionDigits = 2
      minimumFractionDigits = 2
      value /= 100
      break
  }

  const finalMaximumFractionDigits = args?.maximumFractionDigits ?? maximumFractionDigits
  const finalMinimumFractionDigits = Math.min(
    args?.minimumFractionDigits ?? minimumFractionDigits,
    finalMaximumFractionDigits
  )

  return Intl.NumberFormat('en-US', {
    minimumFractionDigits: finalMinimumFractionDigits,
    maximumFractionDigits: finalMaximumFractionDigits,
    useGrouping,
    ...(format === NumberFormat.Currency
      ? {
          style: 'currency',
          currency: 'USD',
        }
      : {}),
    ...(format === NumberFormat.Percentage
      ? {
          style: 'percent',
        }
      : {}),
  }).format(value)
}
